import React from "react";

import { useTheme } from "../../../../context/theme";
import { Role } from "../../../../styles/colors/types";
import { ResponsiveDimension } from "../../../../types";
import { Box, Center } from "../../../layout";
import { SecondaryCircleWidthAndHeight } from "../consts";

type Props = {
  size: SecondaryCircleWidthAndHeight;
  padding?: ResponsiveDimension;
  children: React.ReactNode;
  backgroundColor?: Role;
};
export default function SecondaryCircle({
  size,
  padding = "none",
  children,
  backgroundColor
}: Props) {
  const theme = useTheme();

  return (
    <Box
      width={size}
      height={size}
      borderRadius="xxxlarge"
      backgroundColor={backgroundColor ? theme[backgroundColor] : undefined}
      position="absolute"
      bottom="-3.12%"
      top="62.5%"
      right="-3.12%"
      left="62.5%"
      padding={padding}
    >
      <Center>{children}</Center>
    </Box>
  );
}
